module.exports = __webpack_public_path__ + "img/CLongswordsman64_ua.d59b3611.webp";